/**
 * Cookies that are manually stored class
 */

export default class CookiesManual {

    /**
     * @constructor
     */
    constructor(type)
    {
        this.button = $('[data-cookiesManual="' + type + '"');
        this.type = type;

        this.init();
    }

    init()
    {
        $(document).ready(() => {
            this.button.on('click', () => {
                if (this.type === 'register') {
                    this.setRegisterCookie();
                } else if (this.type === 'registerReservation') {
                    this.setRegisterReservationCookie();
                }
            })
        })
    }

    /**
     * Function that calls ajax for setting a cookie
     */
    setRegisterCookie()
    {
		let locale = $('meta[name="country"]').attr('content');

        $.ajax({
            headers: {
                'X-App-Locale': locale
            },
            url: window.origin + '/cookie/set-register',
            method: 'POST',
            success: (data) => {
                window.hidePanel(this.button)
            }
        });
    }

    /**
     * Function that calls ajax for setting a cookie
     */
    setRegisterReservationCookie()
    {
        let locale = $('meta[name="country"]').attr('content');

        $.ajax({
            headers: {
                'X-App-Locale': locale
            },
            url: window.origin + '/cookie/set-register-reservation',
            method: 'POST',
            success: (data) => {
                window.hidePanel(this.button)
            }
        });
    }
}